import { useMemo, useState } from 'react'
import useNavigation from 'core/hooks/navigation/useNavigation'
import Popover from 'core/components/dialogs/Popover'
import { useUserProfile } from 'core/hooks/data/useDataHook'
import { UserProfile } from 'types/entity'
import useRolesAndPermissions from 'core/hooks/user/useRolesAndPermissions'
import { PersonCircle } from 'core/_legacy/icons'
import Icon from 'core/components/icons/Icon'
import { LINK_HC_HELP_CENTER } from 'constants/Links'
import useAuth from 'core/hooks/auth/useAuth'
import { useSettings } from 'core/hooks/settings/useSettings'
import { AccountWorkHoursUrl, AccountProfileUrl } from 'constants/RouteUrls'

const ProfilePopover = () => {
  const { logout } = useAuth()
  const { push, pathname } = useNavigation()
  const [show, setShow] = useState(false)
  const isInTeamsPath = pathname?.toLocaleLowerCase().includes('team')
  const { data: currentUser } = useUserProfile({
    opts: {
      placeholderData: {} as UserProfile
    }
  })
  const {
    permissions: { hasAccessToTeamDashboard },
    hasOnlyRole
  } = useRolesAndPermissions()
  const isOnlyReviewer = hasOnlyRole('isReviewer')
  const { data: settings } = useSettings()
  const isA2 = settings?.featureFlags?.ENABLE_DRIVER_EXPERIENCE === true
  const { token_id } = currentUser?.teams?.[0] ?? {}
  const menu = useMemo(() => {
    return (
      <div className="bg-white shadow-lg rounded-lg mt-14 w-64 -mr-16">
        {isInTeamsPath && (
          <>
            <div
              onClick={() => push('/dashboard')}
              className="hover:text-primary cursor-pointer py-3 px-4 block  font-medium"
            >
              Go to Personal Dashboard
            </div>
            {!isOnlyReviewer && (
              <div
                onClick={() => push(`/team/${token_id}/profile`)}
                className="hover:text-primary cursor-pointer py-3 px-4 block  font-medium"
              >
                Team Settings
              </div>
            )}
          </>
        )}
        {!isInTeamsPath && (
          <>
            {hasAccessToTeamDashboard && !isOnlyReviewer && (
              <div
                onClick={() => push('/teams')}
                className="hover:text-primary cursor-pointer py-3 px-4 block  font-medium"
              >
                Go to Team Dashboard
              </div>
            )}
            <div
              onClick={() =>
                push(isA2 ? AccountWorkHoursUrl : AccountProfileUrl)
              }
              className="hover:text-primary cursor-pointer py-3 px-4 block  font-medium"
            >
              {isA2 ? 'Menu' : 'Personal Settings'}
            </div>
          </>
        )}

        <div
          onClick={() => {
            window.open(LINK_HC_HELP_CENTER, '_blank')
          }}
          className="hover:text-primary cursor-pointer py-3 px-4 block  font-medium"
        >
          Help
        </div>
        <div
          onClick={() => logout()}
          className="hover:text-primary cursor-pointer py-3 px-4 block  font-medium"
        >
          Logout
        </div>
      </div>
    )
  }, [
    hasAccessToTeamDashboard,
    isA2,
    isInTeamsPath,
    isOnlyReviewer,
    logout,
    push,
    token_id
  ])

  return (
    <div className="z-20">
      <Popover
        content={menu}
        show={show}
        position="left-middle"
        useArrow={false}
      >
        <div
          onClick={() => setShow(!show)}
          onBlur={() => setShow(false)}
          tabIndex={0}
          className="cursor-pointer select-none"
        >
          <div className="flex items-center gap-2 cursor-pointer">
            <PersonCircle color="#31b59f" height={'20'} width={'20'} />
            <Icon name="chevron-down" className="text-primary" size={12} />
          </div>
        </div>
      </Popover>
    </div>
  )
}

export default ProfilePopover
